import type { Route } from '@angular/router';
import { offerCategoryRoutes } from './category/offer-category.routes';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';
import { showToasterDeactivateGuard } from '@pct-ng/form';

export const offerRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/offer-list.component').then(({ OfferListComponent }) => OfferListComponent),
    pathMatch: 'full',
  },
  {
    path: 'category',
    children: offerCategoryRoutes,
    title: 'PAGES.OFFER.CATEGORY.BREADCRUMB.LIST',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/offer-details.component').then(
        ({ OfferDetailsComponent }) => OfferDetailsComponent,
      ),
    title: 'PAGES.OFFER.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.OFFER.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/offer-details.component').then(
        ({ OfferDetailsComponent }) => OfferDetailsComponent,
      ),
    title: 'PAGES.OFFER.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.OFFER.SINGULAR'),
      ]),
    ],
  },
];
